import Domains from './Domains';

export default Domains;
